import { useMutation, useQuery } from "react-query";
import { AxiosResponse } from "axios";
import { UserDid} from "../../interfaces/Did.type";
import { AppDispatch } from "../../store/store";
import { useDispatch } from "react-redux";
import { api } from "@data-phone/react-resource-server-auth";
import { addDidUserSlice, deleteDidUserSlice, setDidUsersSlice, updateDidUserSlice } from "../../store/slices/users.slice";


const addUserDid = async (data: UserDid) => {
  const response: AxiosResponse = await api.post(
    `${process.env.REACT_APP_SMS_API_URL}/did/users`,
    data
  );
  return response.data;
}

const updateUserDid = async ( data: {
  id: string
  data: UserDid
  }) => {
  const response: AxiosResponse = await api.put(
    `${process.env.REACT_APP_SMS_API_URL}/did/users/${data.data.did}/${data.id}`,
    data.data
  );
  return response.data;
}

const deleteUserDid = async (did: string, user_id: string, dispatch: AppDispatch) => {
  const response: AxiosResponse = await api.delete(
    `${process.env.REACT_APP_SMS_API_URL}/did/users/${did}/${user_id}`,
  );
  dispatch(deleteDidUserSlice({
    did,
    user_id
  }))
  return response.data;
}

const fetchDidsUsersByAccount = async (account_id: string) => {
  const response: AxiosResponse = await api.get(
    `${process.env.REACT_APP_SMS_API_URL}/did/users/${account_id}`,
  );
  return response.data;
};


export const useGetDidUsersByAccount = (account_id: string) => {
  const dispatch: AppDispatch = useDispatch();
  return useQuery("didUsers", () => fetchDidsUsersByAccount(account_id), {
    enabled: false,
    onSuccess: (data) => {
      dispatch(setDidUsersSlice(data))
    }
  })
}


export const useAddUserDid = () => {
  const dispatch: AppDispatch = useDispatch();
  return useMutation((data: UserDid) => addUserDid(data), {
    onSuccess: (data) => {
      dispatch(addDidUserSlice(data))
    }
  })
}

export const useUpdateUserDid = () => {
  const dispatch: AppDispatch = useDispatch();
  return useMutation((data:{
    id: string
    data: UserDid
  }) => updateUserDid(data), {
    onSuccess: (data) => {
      dispatch(updateDidUserSlice(data))
    }
  })
}

export const useDeleteUserDid = () => {
  const dispatch: AppDispatch = useDispatch();
  return useMutation((data: { did: string, user_id: string }) => deleteUserDid(data.did, data.user_id, dispatch))
}